import { Grid, Box, Typography } from '@mui/material';
import { ReactElement } from 'react';

const EmptyPlaceholder = (props: any): ReactElement => {
    const { icon, message } = props;
    return (
        <Grid
            className="empty-content"
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
        >
            {icon}
            <Box mt={2} className="empty-text">
                <Typography className="white">{message}</Typography>
            </Box>
        </Grid>
    );
};

export default EmptyPlaceholder;
